
import XHeader from 'vux/src/components/x-header/index.vue'

import { log } from 'util';


export default {
components: {
XHeader
},
data () {
return {
showLeft:false,
showRight:false,
wdSwitch:false,
zySwitch:false,
catalogCur:0,
result:[],
menuList:[],
model:{docId : this.$route.query.docId,docTypeId: this.$route.query.docTypeId},
parentMask:[],
content:[],
chapterName:[],
imgsrc: '',
imgIsShow: false,
arr:[]
}
},
created(){
this.getMenu();
this.getSearch();
this.searchContent=this.$route.query.searchContent;

},
methods: {
goBack(){
if(this.searchContent!=null && this.searchContent.length>0){
this.$router.push({
path : '/doc/search',
query : {'searchContent':this.searchContent}
})
}else{
this.$router.push({
path : '/doc/index',
query : {}
})
}

},
scrollEvent(e){
let scrollItems = document.querySelectorAll('.d_jump')
for (let i = scrollItems.length - 1; i >= 0; i--) {

let judge = e.target.scrollTop >= scrollItems[i].offsetTop - scrollItems[0].offsetTop
if (judge) {
this.catalogCur = i
break
}
}


if(e.srcElement.scrollTop+e.srcElement.offsetHeight==e.srcElement.scrollHeight){
this.catalogCur = this.chapterName.length-1
}
},
getSearch(){
var self=this
this.$http.post(this.global.httpUrl + '/rest/v1/m/mdoc/getDetail',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.result= res.body.guide.rows[0];
this.content= res.body.content;
if(res.body.content[0]){
var content= res.body.content[0].content;



for(var i=0;i<this.content.length;i++){
var content=this.content[i].content;
if(content){

content= content.replace(/<img[^>]*>/gi, function (match, capture) {
match=match.replace(/width="[^"]*?"/g,'');
match= match.replace(/height="[^"]*?"/g,'');
match=match.replace(/style\s*?=\s*?([‘"])[\s\S]*?\1/ig, 'style="float: left;"') 
return match;
})
content= content.replace(/<table[^>]*>/gi, function (match, capture) {
return match.replace(/width="[^"]*?"/g,'');
})

content= content.replace(/pre/g,'div style="display: inline-block;word-break: break-all;word-wrap: break-word;"');
this.content[i].content=content;
}
}
}

this.chapterName = res.body.chapterName;
self.showLeft=false

if(res.body.guide.rows[0] != undefined){
this.parentMask.push(res.body.guide.rows[0].parentMask.split("_"));

for(var i=0;i< this.parentMask[0].length;i++){
if(this.parentMask[0][i]== ""){
this.parentMask[0].splice(i,1);
}
}
if(this.parentMask[0].length>0){
for(var i=0;i<this.menuList.length;i++){
if(this.menuList[i].docTypeId==this.parentMask[0][0]){
this.menuList[i].wdSwitch=true;
}
}
}
}
}
},function(res){
});
},
jump (index) {
this.catalogCur=index;
this.showRight=false
let jump = document.querySelectorAll('.d_jump')
jump[index].scrollIntoView({block: "start", behavior: "smooth"});
},
getMenu(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/mdoc/getMenus',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.menuList= res.body.menu;
var bin=this.menuList.length;
for(var i=0;i<bin;i++){
this.menuList[i].wdSwitch=false ;
}
}
},function(res){
});
},
getPh(index){
this.menuList[index].wdSwitch = !this.menuList[index].wdSwitch
let tempArr = JSON.parse(JSON.stringify(this.menuList))
this.menuList = []
this.$nextTick(() => {
this.menuList = tempArr
})
},
liClick(e){
if(e.currentTarget.classList.contains("open")){
e.currentTarget.classList.remove("open")
}else{
e.currentTarget.classList.add("open")
}
},
getTwoStatus(ite){
if(this.parentMask != "" || this.parentMask[0] != undefined){
if(this.parentMask[0].length>1){
if(ite.docTypeId==this.parentMask[0][1]){
return "open";
}
}
}
},
getThreeStatus(it){
if(this.parentMask != "" || this.parentMask[0] != undefined){
if(this.parentMask[0].length>2){
if(it.docTypeId==this.parentMask[0][2]){
return "open";
}
}
}
},
getFourStatus(i){
var textId=this.$route.query.docTypeId;
if(textId==i.docTypeId){
return "active";
}
},
goUrl(i){
this.$router.push({path:'detail',query:{'docTypeId':i.docTypeId}})
this.model.docTypeId=i.docTypeId;
this.getSearch();
},
imgonclick(e){
var obj=e.target;
if(obj.src){

var imgsrc = obj.src;

this.imgIsShow=true;
this.imgsrc=imgsrc;
}

}
}
}






// WEBPACK FOOTER //
// ./src/views/doc/docDetail.vue